// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__nA9XN","videoBg":"Hero_videoBg__Sh3tM","overlay":"Hero_overlay__ZLr78","content":"Hero_content__upM2-","button":"Hero_button__wLv9n"};